import React from 'react';
import { Div } from '@kizi/core-components';

export const TextWithLink = ({ children }) => {
  return (
    <Div
      css={{
        '>p': {
          color: 'text',
          fontFamily: 'body',
          fontSize: 3,
          lineHeight: 2,
          fontWeight: 0,
          maxWidth: '100%',
        },
      }}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
};
